var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c("div", {}, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            "background-color": "#FFFFFF",
            "border-radius": "20px",
            padding: "20px 0",
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "demo-form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "支付宝APPID", prop: "alipayAppId" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "800px" },
                    attrs: { placeholder: "请输入", clearable: "" },
                    model: {
                      value: _vm.form.alipayAppId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "alipayAppId", $$v)
                      },
                      expression: "form.alipayAppId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "支付宝公钥", prop: "publicKey" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "800px" },
                    attrs: {
                      placeholder: "请输入",
                      clearable: "",
                      type: "textarea",
                      rows: 4,
                    },
                    model: {
                      value: _vm.form.publicKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "publicKey", $$v)
                      },
                      expression: "form.publicKey",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "text" }, [
                    _vm._v(
                      "\n            请将生成的txt文件【文件名：alipayPublicKey_RSA2.txt】用 “记事本” 打开 ，全选复制文件内信息并粘贴在此处\n          "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "应用私钥", prop: "privateKey" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "800px" },
                    attrs: {
                      placeholder: "请输入",
                      clearable: "",
                      type: "textarea",
                      rows: 4,
                    },
                    model: {
                      value: _vm.form.privateKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "privateKey", $$v)
                      },
                      expression: "form.privateKey",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "text" }, [
                    _vm._v(
                      "\n            请将支付宝开放平台密钥工具生成的【文件名：应用私钥RSA2048***.txt】打开，全选复制文件内信息并粘贴在此处\n          "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v(" 保存 ")]
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.handleReset } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          "margin-bottom": "10px",
          color: "#F59A23",
          "background-color": "#FFFFFF",
          padding: "15px",
          "border-radius": "10px",
        },
      },
      [
        _c("div", [
          _vm._v(
            "\n        1.什么是“收款账号”：收款账号指用户向平台进行付款操作时，平台收款使用的支付宝账号\n      "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { "margin-top": "5px" } }, [
          _vm._v(
            "\n        2.当用户进行“付费修改邀请码”、“付费升级”、“淘礼金充值”以及“使用云发单功能”时会使用到，不配置将无法使用这些功能\n      "
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }